module.exports = __webpack_public_path__ + "img/d874439.png";